import { defineStore } from 'pinia';

export const useLanguageStore = defineStore('language', {
  state: () => ({
    language: 'de'
  }),
  actions: {
    setLanguage(lang: string) {
      this.language = lang;
    }
  }
});